import { SocialNetwoksRealNames, SocialNetworkLinks, SocialNetworkNames } from '../enum/provider'

export const returnIconByAppName = (name : string) => {
    let res = ''
    switch (name) {
      case 'facebookID':
        res = SocialNetworkNames.facebook
        break
      case 'twitterScreenName':
        res = SocialNetworkNames.twitter
        break
      case 'googlePlusID':
        res = SocialNetworkNames.googlePlus
        break
      case 'linkedinPubProfileUrl':
        res = SocialNetworkNames.linkedin
        break
      case 'instagramID' : 
        res = SocialNetworkNames.instagram
        break
    }
    console.log(name, res)
    return res
  }

  export const returnLinkToSocialNetwork = (name : string, id : string) : string => {
  
      switch (returnIconByAppName(name)) {
        case SocialNetworkNames.facebook:
          return SocialNetworkLinks.facebook + id
        case SocialNetworkNames.linkedin:
          return id
        case SocialNetworkNames.twitter: 
          return SocialNetworkLinks.twitter + id
        case SocialNetworkNames.instagram : 
          return SocialNetworkLinks.instagram + id
        case SocialNetworkNames.googlePlus : 
          return SocialNetworkLinks.googlePlus + id
      }
      return ""
    }

    export const convertToRealName = (jsonName : string) : string => {
      switch (returnIconByAppName(jsonName)) {
        case SocialNetworkNames.facebook:
          return SocialNetwoksRealNames.facebook
        case SocialNetworkNames.linkedin:
          return SocialNetwoksRealNames.linkedin
        case SocialNetworkNames.twitter: 
          return SocialNetwoksRealNames.twitter
        case SocialNetworkNames.instagram : 
          return SocialNetwoksRealNames.instagram
        case SocialNetworkNames.googlePlus : 
          return SocialNetwoksRealNames.googlePlus
      }
      return ""
    }